/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Notification_Copyfailed3Inputs */

const id_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal menyalin kunci API`)
};

const ms_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal menyalin kunci API`)
};

const da_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke kopiere API nøgle`)
};

const de_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel konnte nicht kopiert werden`)
};

const en_us2_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy API key`)
};

const es_es2_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al copiar la clave de API`)
};

const es_mx2_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al copiar la API key`)
};

const fil_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigong kopyahin ang API key`)
};

const fr_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la copie de la clé API`)
};

const it_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile copiare la chiave API`)
};

const hu_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikertelen API kulcs másolás`)
};

const nl_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutel kopiëren mislukt`)
};

const no_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke kopiere API-nøkkel`)
};

const pl_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się skopiować klucza API`)
};

const pt_br2_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy API key`)
};

const pt_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao copiar chave de API`)
};

const ro_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copierea cheii API a eșuat`)
};

const fi_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avaimen kopiointi epäonnistui`)
};

const sv_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misslyckades att kopiera API-nyckel`)
};

const vi_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể sao chép khóa API`)
};

const tr_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarı kopyalanamadı`)
};

const cs_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepodařilo se zkopírovat API klíč`)
};

const bg_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешно копиране на API ключ`)
};

const ru_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось скопировать API-ключ`)
};

const uk_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося скопіювати API-ключ`)
};

const ar_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل نسخ مفتاح API`)
};

const hi_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी करने में विफल`)
};

const th_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอกคีย์ API ไม่สำเร็จ`)
};

const ja_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーのコピーに失敗しました`)
};

const zh_cn2_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy API key`)
};

const zh_hant1_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy API key`)
};

const ko_components_apikeymanager_notification_copyfailed3 = /** @type {(inputs: Components_Apikeymanager_Notification_Copyfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy API key`)
};

/**
* | output |
* | --- |
* | "Failed to copy API key" |
*
* @param {Components_Apikeymanager_Notification_Copyfailed3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_notification_copyfailed3 = /** @type {((inputs?: Components_Apikeymanager_Notification_Copyfailed3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Notification_Copyfailed3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "ms") return ms_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "da") return da_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "de") return de_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "fil") return fil_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "fr") return fr_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "it") return it_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "hu") return hu_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "nl") return nl_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "no") return no_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "pl") return pl_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "pt") return pt_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "ro") return ro_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "fi") return fi_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "sv") return sv_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "vi") return vi_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "tr") return tr_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "cs") return cs_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "bg") return bg_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "ru") return ru_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "uk") return uk_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "ar") return ar_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "hi") return hi_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "th") return th_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "ja") return ja_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_notification_copyfailed3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_notification_copyfailed3(inputs)
	return ko_components_apikeymanager_notification_copyfailed3(inputs)
});
export { components_apikeymanager_notification_copyfailed3 as "components.apiKeyManager.notification.copyFailed" }